import ImportHelper from './import.helper'

const GeneralView = () => { return ImportHelper.importAll(require.context("../assets/images/GeneralView/", true, /\.webp/)); }
const PortoNovo = () => {return ImportHelper.importAll(require.context("../assets/images/PortoNovo/", true, /\.webp/)); }
const TorreD = () => {return ImportHelper.importAll(require.context("../assets/images/TorreD/", true, /\.webp/)); }
const TorreE = () => {return ImportHelper.importAll(require.context("../assets/images/TorreE/", true, /\.webp/)); }
const PorteriaPortoNovo = () => {return ImportHelper.importAll(require.context("../assets/images/PorteriaPortoNovo/", true, /\.webp/)); }
const PiscinaPortoNovo = () => {return ImportHelper.importAll(require.context("../assets/images/PiscinaPortoNovo/", true, /\.webp/)); }
const PiscinaAntao = () => {return ImportHelper.importAll(require.context("../assets/images/PiscinaAntao/", true, /\.webp/)); }
const PorteriaAntao = () => {return ImportHelper.importAll(require.context("../assets/images/PorteriaAntao/", true, /\.webp/)); }
const Antao = () => {return ImportHelper.importAll(require.context("../assets/images/Antao/", true, /\.webp/)); }
const AntaoEtapa2 = () => {return ImportHelper.importAll(require.context("../assets/images/Etapa2/", true, /\.webp/)); }

export const ContextLoader = {
    "General View": GeneralView,
    "Porto Novo": PortoNovo,
    "Antao": Antao,
    "Portería Porto Novo": PorteriaPortoNovo,
    "Piscina adultos Porto Novo": PiscinaPortoNovo,
    "Portería Antao": PorteriaAntao,
    "Piscina adultos Antao": PiscinaAntao,
    "Etapa 2": AntaoEtapa2,
    "Torre D": TorreD,
    "Torre E": TorreE,
}
